module.exports = __webpack_public_path__ + "img/inspirer-of-ideas.b50a85c8.svg";